(function () {
'use strict';
var NV = window.NV = window.NV || {};
NV.formatMoney = function (cents, format) {
if (typeof cents === 'string') cents = cents.replace('.', '');
format = format || (window.theme && theme.settings && theme.settings.moneyFormat) || NV.moneyFormat || '${{amount}}';
var placeholder = /\{\{\s*(\w+)\s*\}\}/;
function fmt(number, precision, thousands, decimal) {
precision = precision == null ? 2 : precision;
thousands = thousands || ',';
decimal = decimal || '.';
if (isNaN(number) || number == null) return '0';
number = (number / 100.0).toFixed(precision);
var parts = number.split('.');
var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
var c = parts[1] ? decimal + parts[1] : '';
return dollars + c;
}
var m = format.match(placeholder);
var value = '';
switch (m ? m[1] : 'amount') {
case 'amount_no_decimals': value = fmt(cents, 0); break;
case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
default: value = fmt(cents, 2);
}
return format.replace(placeholder, value);
};
function qs(root, sel) { return root.querySelector(sel); }
function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
NV.addToCart = function (items) {
return fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
body: JSON.stringify({ items: items })
}).then(function (res) {
return res.json().then(function (data) {
if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
return data;
});
});
};
NV.openCart = function (data) {
var openedBefore = document.querySelector('.drawer--is-open, .is-open[id*="Cart"], cart-drawer.active');
var first = data && data.items ? data.items[0] : data;
document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: first, addToCartBtn: null } }));
document.dispatchEvent(new CustomEvent('cart:build'));
document.dispatchEvent(new CustomEvent('cart:open'));
if (window.theme && typeof theme.openCartDrawer === 'function') { try { theme.openCartDrawer(); } catch (e) {} }
setTimeout(function () {
var open = document.querySelector('#CartDrawer.drawer--is-open, .drawer--is-open#CartDrawer, .js-drawer-open-cart.drawer--is-open, html.js-drawer-open, body.js-drawer-open, cart-drawer.active');
if (!open && !openedBefore) window.location.href = '/cart';
}, 900);
};
function Product(root) {
this.root = root;
var jsonEl = qs(root, '[data-nv-product-json]');
this.product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
if (!this.product) return;
this.variants = this.product.variants;
this.hasVariants = !(this.variants.length === 1 && this.variants[0].title === 'Default Title');
this.currentVariant = this.variants.find(function (v) { return v.id === Number(root.dataset.selectedVariant); }) || this.variants.find(function (v) { return v.available; }) || this.variants[0];
this.initGallery();
this.initPills();
this.initOffers();
this.initAtc();
this.initModals();
this.render();
}
Product.prototype.findVariant = function (options) {
return this.variants.find(function (v) {
return options.every(function (val, i) { return v.options[i] === val; });
});
};
Product.prototype.initGallery = function () {
var self = this;
var g = qs(this.root, '[data-nv-gallery]');
if (!g) return;
this.gallery = g;
var track = qs(g, '.nv-gallery__track');
var slides = qsa(g, '.nv-gallery__slide');
var thumbs = qsa(g, '.nv-gallery__thumb');
var counter = qs(g, '[data-nv-counter]');
this.slides = slides;
if (!track || !slides.length) return;
var current = 0;
function setActive(i) {
current = i;
if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === i); });
var at = thumbs[i];
if (at && at.parentNode) {
var p = at.parentNode;
var left = at.offsetLeft - p.clientWidth / 2 + at.clientWidth / 2;
p.scrollTo({ left: left, behavior: 'smooth' });
}
qsa(g, 'video').forEach(function (v, vi) { if (!slides[i].contains(v)) v.pause(); });
}
this.goTo = function (i) {
if (i < 0) i = slides.length - 1;
if (i >= slides.length) i = 0;
track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
setActive(i);
};
var t;
track.addEventListener('scroll', function () {
clearTimeout(t);
t = setTimeout(function () {
var i = Math.round(track.scrollLeft / track.clientWidth);
if (i !== current) setActive(Math.max(0, Math.min(slides.length - 1, i)));
}, 60);
}, { passive: true });
thumbs.forEach(function (th, i) { th.addEventListener('click', function () { self.goTo(i); }); });
var prev = qs(g, '[data-nv-prev]'), next = qs(g, '[data-nv-next]');
if (prev) prev.addEventListener('click', function () { self.goTo(current - 1); });
if (next) next.addEventListener('click', function () { self.goTo(current + 1); });
setActive(0);
var lb = qs(this.root, '[data-nv-lightbox]');
if (lb) {
slides.forEach(function (s, i) {
if (s.dataset.mediaType !== 'image') return;
s.addEventListener('click', function () {
lb.classList.add('is-open'); document.body.classList.add('nv-lock');
var img = qsa(lb, 'img')[s.dataset.imageIndex | 0];
if (img) setTimeout(function () { img.scrollIntoView({ block: 'start' }); }, 30);
});
});
qs(lb, '[data-nv-lightbox-close]').addEventListener('click', function () { lb.classList.remove('is-open'); document.body.classList.remove('nv-lock'); });
}
};
Product.prototype.showVariantMedia = function (variant) {
if (!variant || !variant.featured_media || !this.slides || !this.goTo) return;
var id = String(variant.featured_media.id);
var idx = this.slides.findIndex(function (s) { return s.dataset.mediaId === id; });
if (idx > -1) this.goTo(idx);
};
Product.prototype.initPills = function () {
var self = this;
var wrap = qs(this.root, '[data-nv-variants]');
if (!wrap) return;
this.pillWrap = wrap;
qsa(wrap, '[data-nv-pill]').forEach(function (btn) {
btn.addEventListener('click', function () {
var group = btn.closest('[data-nv-option]');
qsa(group, '[data-nv-pill]').forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
btn.classList.add('is-selected'); btn.setAttribute('aria-pressed', 'true');
var label = qs(group, '[data-nv-option-value]'); if (label) label.textContent = btn.dataset.value;
var opts = qsa(wrap, '[data-nv-option]').map(function (gp) { var s = qs(gp, '.is-selected'); return s ? s.dataset.value : null; });
var v = self.findVariant(opts);
if (v) { self.currentVariant = v; self.showVariantMedia(v); }
self.render();
});
});
};
Product.prototype.initOffers = function () {
var self = this;
var wrap = qs(this.root, '[data-nv-offers]');
if (!wrap) return;
this.offerWrap = wrap;
this.offers = qsa(wrap, '[data-nv-offer]');
this.offers.forEach(function (offer) {
offer.addEventListener('click', function (e) {
if (e.target.closest('select')) return;
self.selectOffer(offer);
});
offer.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { if (e.target.closest('select')) return; e.preventDefault(); self.selectOffer(offer); } });
function onRowChange(el) {
var row = el.closest('[data-nv-row]');
self.syncRow(row);
var v = self.rowVariant(row);
if (v) { self.currentVariant = v; self.showVariantMedia(v); }
self.render();
}
qsa(offer, 'select').forEach(function (sel) { sel.addEventListener('change', function () { onRowChange(sel); }); });
qsa(offer, '[data-nv-sw]').forEach(function (btn) {
btn.addEventListener('click', function () {
var group = btn.closest('[data-nv-sw-group]');
qsa(group, '[data-nv-sw]').forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
btn.classList.add('is-selected'); btn.setAttribute('aria-pressed', 'true');
var nm = qs(group, '[data-nv-sw-name]'); if (nm) nm.textContent = btn.dataset.value;
onRowChange(btn);
});
});
});
qsa(wrap, '[data-nv-row]').forEach(function (r) { self.syncRow(r); });
var pre = this.offers.find(function (o) { return o.classList.contains('is-selected'); }) || this.offers[0];
if (pre) this.selectOffer(pre, true);
};
Product.prototype.rowVariant = function (row) {
if (!this.hasVariants) return this.variants[0];
var opts = qsa(row, '[data-nv-opt]').map(function (el) {
if (el.tagName === 'SELECT') return el.value;
var sel = qs(el, '.is-selected');
return sel ? sel.dataset.value : null;
});
return this.findVariant(opts);
};
Product.prototype.syncRow = function (row) {
var self = this;
var ctrls = qsa(row, '[data-nv-opt]');
if (!ctrls.length) return;
function read() { return ctrls.map(function (el) { if (el.tagName === 'SELECT') return el.value; var s = qs(el, '.is-selected'); return s ? s.dataset.value : null; }); }
function write(i, val) {
var el = ctrls[i];
if (el.tagName === 'SELECT') { el.value = val; return; }
qsa(el, '[data-nv-sw]').forEach(function (b) { var on = b.dataset.value === val; b.classList.toggle('is-selected', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
var nm = qs(el, '[data-nv-sw-name]'); if (nm) nm.textContent = val;
}
var opts = read();
if (!self.findVariant(opts)) {
for (var k = opts.length - 1; k >= 1; k--) {
var prefix = opts.slice(0, k);
var m = self.variants.find(function (v) { return prefix.every(function (val, i) { return v.options[i] === val; }); });
if (m) { m.options.forEach(function (val, i) { write(i, val); }); break; }
}
opts = read();
}
ctrls.forEach(function (el, i) {
var test = opts.slice();
if (el.tagName === 'SELECT') {
qsa(el, 'option').forEach(function (o) { test[i] = o.value; o.disabled = !self.findVariant(test); });
} else {
qsa(el, '[data-nv-sw]').forEach(function (b) { test[i] = b.dataset.value; b.classList.toggle('is-unavailable', !self.findVariant(test)); });
}
});
};
Product.prototype.selectOffer = function (offer, silent) {
this.offers.forEach(function (o) { o.classList.toggle('is-selected', o === offer); o.setAttribute('aria-checked', o === offer ? 'true' : 'false'); });
this.activeOffer = offer;
if (!silent) this.render(); else this.render();
};
Product.prototype.selection = function () {
var self = this;
var items = [];
if (this.activeOffer) {
var qty = Number(this.activeOffer.dataset.qty) || 1;
var rows = qsa(this.activeOffer, '[data-nv-row]');
if (this.hasVariants && rows.length) {
rows.slice(0, qty).forEach(function (r) { var v = self.rowVariant(r); items.push(v || null); });
} else {
for (var i = 0; i < qty; i++) items.push(self.hasVariants ? self.currentVariant : self.variants[0]);
}
} else {
var q = qs(this.root, '[data-nv-qty]');
var n = q ? Math.max(1, Number(q.value) || 1) : 1;
for (var j = 0; j < n; j++) items.push(this.currentVariant);
}
return items;
};
Product.prototype.offerTotals = function (offer) {
var self = this;
var qty = Number(offer.dataset.qty) || 1;
var pct = Number(offer.dataset.discount) || 0;
var rows = qsa(offer, '[data-nv-row]');
var free = Number(offer.dataset.free) || 0;
var prices = [], compare = 0;
for (var i = 0; i < qty; i++) {
var v = (this.hasVariants && rows[i]) ? (self.rowVariant(rows[i]) || self.currentVariant) : self.currentVariant;
prices.push(v.price);
compare += (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : v.price;
}
prices.sort(function (a, b) { return a - b; });
var total = prices.slice(free).reduce(function (a, b) { return a + b; }, 0);
var discounted = Math.round(total * (100 - pct) / 100);
return { price: discounted, compare: compare > discounted ? compare : 0 };
};
Product.prototype.render = function () {
var self = this;
var v = this.currentVariant;
var idInput = qs(this.root, '[data-nv-variant-id]');
if (idInput && v) idInput.value = v.id;
if (this.offers) {
this.offers.forEach(function (o) {
var t = self.offerTotals(o);
var p = qs(o, '[data-nv-offer-price]'), c = qs(o, '[data-nv-offer-compare]');
if (p) p.textContent = NV.formatMoney(t.price);
if (c) c.textContent = t.compare ? NV.formatMoney(t.compare) : '';
});
}
var priceNow = qs(this.root, '[data-nv-price]'), priceWas = qs(this.root, '[data-nv-compare]'), save = qs(this.root, '[data-nv-save]');
if (priceNow && v) {
priceNow.textContent = NV.formatMoney(v.price);
var on = v.compare_at_price && v.compare_at_price > v.price;
if (priceWas) priceWas.textContent = on ? NV.formatMoney(v.compare_at_price) : '';
if (save) {
var tpl = save.dataset.template || 'Save [percent]%';
save.textContent = on ? tpl.replace('[percent]', Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price)).replace('[amount]', NV.formatMoney(v.compare_at_price - v.price)) : '';
}
}
var items = this.selection();
var allOk = items.length && items.every(function (it) { return it && it.available; });
var total = 0;
if (this.activeOffer) total = this.offerTotals(this.activeOffer).price;
else items.forEach(function (it) { if (it) total += it.price; });
qsa(document, '[data-nv-atc-button]').forEach(function (btn) {
if (btn.dataset.productId && Number(btn.dataset.productId) !== self.product.id) return;
var label = qs(btn, '[data-nv-atc-label]');
var priceEl = qs(btn, '[data-nv-atc-price]');
btn.disabled = !allOk;
if (label) label.textContent = allOk ? btn.dataset.labelAdd : (items.some(function (i) { return !i; }) ? btn.dataset.labelUnavailable : btn.dataset.labelSoldout);
if (priceEl) priceEl.textContent = allOk && btn.dataset.showPrice === 'true' ? '· ' + NV.formatMoney(total) : '';
});
qsa(document, '[data-nv-sticky-price]').forEach(function (el) { el.textContent = NV.formatMoney(total || (v ? v.price : 0)); });
};
Product.prototype.initAtc = function () {
var self = this;
qsa(document, '[data-nv-atc-button]').forEach(function (btn) {
if (btn.dataset.productId && Number(btn.dataset.productId) !== self.product.id) return;
if (btn.__nvBound) return; btn.__nvBound = true;
btn.addEventListener('click', function (e) {
e.preventDefault();
var items = self.selection();
if (!items.length || items.some(function (i) { return !i || !i.available; })) return;
var map = {};
var order = [];
items.forEach(function (it) { if (!map[it.id]) { map[it.id] = 0; order.push(it.id); } map[it.id]++; });
var payload = order.map(function (id) {
var line = { id: id, quantity: map[id] };
if (self.activeOffer && self.activeOffer.dataset.offerName) line.properties = { _bundle: self.activeOffer.dataset.offerName };
return line;
});
var err = qs(self.root, '[data-nv-atc-error]');
if (err) err.classList.remove('is-visible');
btn.classList.add('is-loading');
NV.addToCart(payload).then(function (data) {
btn.classList.remove('is-loading');
if (btn.dataset.skipCart === 'true') { window.location.href = '/checkout'; return; }
NV.openCart(data);
}).catch(function (ex) {
btn.classList.remove('is-loading');
if (err) { err.textContent = ex.message; err.classList.add('is-visible'); }
else alert(ex.message);
});
});
});
};
Product.prototype.initModals = function () {
qsa(this.root, '[data-nv-modal-open]').forEach(function (btn) {
var modal = document.getElementById(btn.dataset.nvModalOpen);
if (!modal) return;
if (modal.parentNode !== document.body) document.body.appendChild(modal);
btn.addEventListener('click', function () { modal.classList.add('is-open'); document.body.classList.add('nv-lock'); });
function close() { modal.classList.remove('is-open'); document.body.classList.remove('nv-lock'); }
qsa(modal, '[data-nv-modal-close]').forEach(function (c) { c.addEventListener('click', close); });
modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
});
};
function addBusinessDays(date, days, skipWeekends) {
var d = new Date(date.getTime());
var added = 0;
while (added < days) {
d.setDate(d.getDate() + 1);
if (!skipWeekends || (d.getDay() !== 0 && d.getDay() !== 6)) added++;
}
return d;
}
function fmtDate(d, style) {
try { return d.toLocaleDateString(document.documentElement.lang || 'en-US', style === 'long' ? { weekday: 'short', month: 'short', day: 'numeric' } : { month: 'short', day: 'numeric' }); }
catch (e) { return (d.getMonth() + 1) + '/' + d.getDate(); }
}
NV.initDelivery = function (root) {
qsa(root, '[data-nv-delivery]').forEach(function (el) {
var skip = el.dataset.skipWeekends === 'true';
var now = new Date();
var shipMin = addBusinessDays(now, Number(el.dataset.shipMin) || 1, skip);
var shipMax = addBusinessDays(now, Number(el.dataset.shipMax) || 2, skip);
var delMin = addBusinessDays(now, Number(el.dataset.delMin) || 5, skip);
var delMax = addBusinessDays(now, Number(el.dataset.delMax) || 8, skip);
var hoursLeft = 24 - now.getHours();
var s = qs(el, '[data-nv-de-sentence]');
if (s) s.textContent = (s.dataset.template || '').replace('[hours]', hoursLeft + (hoursLeft === 1 ? ' hour' : ' hours'));
var set = function (sel, txt) { var x = qs(el, sel); if (x) x.textContent = txt; };
set('[data-nv-de-dates]', fmtDate(delMin, 'long') + ' – ' + fmtDate(delMax, 'long'));
set('[data-nv-de-ordered]', fmtDate(now));
set('[data-nv-de-shipped]', fmtDate(shipMin) + (shipMax.getTime() !== shipMin.getTime() ? ' – ' + fmtDate(shipMax) : ''));
set('[data-nv-de-delivered]', fmtDate(delMin) + ' – ' + fmtDate(delMax));
});
qsa(root, '[data-nv-delivery-inline]').forEach(function (el) {
var now = new Date();
var d1 = addBusinessDays(now, Number(el.dataset.delMin) || 5, true), d2 = addBusinessDays(now, Number(el.dataset.delMax) || 8, true);
el.textContent = (el.dataset.template || '').replace('[dates]', fmtDate(d1) + ' – ' + fmtDate(d2));
});
};
NV.initTimers = function (root) {
qsa(root, '[data-nv-timer]').forEach(function (el) {
if (el.__nvTimer) clearInterval(el.__nvTimer);
var mode = el.dataset.mode || 'midnight';
var end;
function target() {
var now = new Date();
if (mode === 'date' && el.dataset.end) {
var t = new Date(el.dataset.end);
if (!isNaN(t) && t > now) return t;
}
var hours = Number(el.dataset.hours) || 24;
if (mode === 'rolling') {
var key = 'nv-timer-' + (el.dataset.key || 'default');
var stored = null;
try { stored = Number(localStorage.getItem(key)); } catch (e) {}
if (!stored || stored < now.getTime()) { stored = now.getTime() + hours * 3600000; try { localStorage.setItem(key, stored); } catch (e) {} }
return new Date(stored);
}
var m = new Date(now); m.setHours(24, 0, 0, 0); return m;
}
end = target();
function pad(n) { return n < 10 ? '0' + n : '' + n; }
function tick() {
var diff = end - new Date();
if (diff <= 0) { end = target(); diff = end - new Date(); }
var s = Math.floor(diff / 1000);
var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
var set = function (k, v) { var x = el.querySelector('[data-' + k + ']'); if (x) x.textContent = pad(v); };
var dayEl = el.querySelector('[data-d]');
if (dayEl) { dayEl.parentNode.style.display = d > 0 ? '' : 'none'; dayEl.textContent = pad(d); set('h', h); }
else set('h', h + d * 24);
set('m', m); set('s', sec);
}
tick();
el.__nvTimer = setInterval(tick, 1000);
});
};
NV.initCarousels = function (root) {
qsa(root, '[data-nv-carousel]').forEach(function (wrap) {
var vp = qs(wrap, '.nv-carousel');
var prev = qs(wrap, '[data-nv-car-prev]'), next = qs(wrap, '[data-nv-car-next]');
if (!vp) return;
function step() { var card = vp.querySelector('.nv-carousel__track > *'); return card ? card.getBoundingClientRect().width + 16 : vp.clientWidth * 0.8; }
function update() {
if (prev) prev.disabled = vp.scrollLeft <= 2;
if (next) next.disabled = vp.scrollLeft + vp.clientWidth >= vp.scrollWidth - 2;
var nav = qs(wrap, '.nv-carousel-nav'); if (nav) nav.hidden = vp.scrollWidth <= vp.clientWidth + 2;
}
if (prev) prev.addEventListener('click', function () { vp.scrollBy({ left: -step(), behavior: 'smooth' }); });
if (next) next.addEventListener('click', function () { vp.scrollBy({ left: step(), behavior: 'smooth' }); });
vp.addEventListener('scroll', update, { passive: true });
window.addEventListener('resize', update);
update();
});
};
NV.initVideos = function (root) {
qsa(root, '[data-nv-vt-card]').forEach(function (card) {
var video = qs(card, 'video');
if (!video) return;
var play = qs(card, '[data-nv-vt-play]'), sound = qs(card, '[data-nv-vt-sound]');
function toggle() {
if (video.paused) {
qsa(document, '[data-nv-vt-card] video').forEach(function (v) { if (v !== video) { v.pause(); v.closest('[data-nv-vt-card]').classList.remove('is-playing'); } });
video.play(); card.classList.add('is-playing');
} else { video.pause(); card.classList.remove('is-playing'); }
}
card.addEventListener('click', function (e) { if (e.target.closest('[data-nv-vt-sound]')) return; toggle(); });
if (sound) sound.addEventListener('click', function (e) {
e.stopPropagation(); video.muted = !video.muted; sound.textContent = video.muted ? sound.dataset.off : sound.dataset.on;
if (!video.muted && video.paused) toggle();
});
});
};
NV.initSticky = function () {
var sticky = document.querySelector('[data-nv-sticky]');
var anchor = document.querySelector('[data-nv-atc-anchor]');
if (!sticky || !anchor || !('IntersectionObserver' in window)) return;
var passed = false;
new IntersectionObserver(function (entries) {
var e = entries[0];
passed = !e.isIntersecting && e.boundingClientRect.top < 0;
sticky.classList.toggle('is-visible', passed);
}).observe(anchor);
var footer = document.querySelector('footer, .site-footer');
if (footer) new IntersectionObserver(function (entries) {
sticky.classList.toggle('is-visible', passed && !entries[0].isIntersecting);
}).observe(footer);
};
function boot(root) {
root = root || document;
qsa(root, '[data-nv-product]').forEach(function (el) { if (!el.__nv) el.__nv = new Product(el); });
NV.initDelivery(root);
NV.initTimers(root);
NV.initCarousels(root);
NV.initVideos(root);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); NV.initSticky(); });
else { boot(); NV.initSticky(); }
document.addEventListener('shopify:section:load', function (e) { boot(e.target); NV.initSticky(); });
})();
